<template>
    <div style="margin-top: 10px">
        
         <div class="validation-section">
            <div class="row">
                <div class="col-md-12">
                    <label>Ingrese el Número de Documento</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input v-model="model.Dni" :maxlength="8"></base-input>
                </div>
            </div>
            <div class="row" style="text-align:right">
                <div class="col-md-12">
                    <base-button type="warning" size="lg" @click="validate" style="margin: auto; margin-top: 10px">
                        <i class="fa fa-check fa-fw"></i> Validar
                    </base-button>
                </div>
            </div>
        </div>

        <div class="recarga-section">
            <div class="row">
                <div class="col-md-12">
                    <label>Cliente</label>
                    <br />
                    <base-input v-model="model.FullName" :disabled="true"></base-input>
                </div>     
            </div> 
            <div class="row">
                <div class="col-md-12">
                    <label>Pack</label>
                    <br />
                    <KitsCombo
                        v-model="model.SelectedValue"
                        v-bind:items="Packs"
                        propertyName="FormattedName"
                        propertyID="EntityID"
                        :todos="true"
                        nullText=" -- Seleccione un Pack -- "
                        v-on:input="change">
                    </KitsCombo>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import notificationHelpers from "@/helpers/notificationHelpers";

    export default {
        components: { KitsCombo, notificationHelpers },
        props: {
                modelProp: {default:{
                Aux1: "",
                Aux2: "",
                Aux3: "",
                Aux4: "",
                Importe: "",
                Validate: false,
                Errors: []
                }
            }   
        },
        data() {
            return {
                model: {
                    Dni:'',
                    FullName: '',
                    ClientID: '',
                    Pack: null,
                    SelectedValue: null,
                    Validate: false,
                    Errors:[]
                },
                Packs: []
            }
        }, 
        mounted()
        {
            let context = this;
            context.model.Dni = '';
            context.model.FullName = '';
            context.model.Pack = null;
            context.model.SelectedValue = null;
            context.model.Packs = null;
        },
        methods: {
            change(val){
                let context = this;
                this.model.Pack = this.Packs.filter(x => x.EntityID == val);
                if(this.model.Pack != null && this.model.Pack != undefined)
                {
                    context.modelProp.Aux1 = context.model.ClientID;
                    context.modelProp.Aux2 = context.model.Pack[0].Name;
                    context.modelProp.Importe = context.model.Pack[0].Price;
                    this.$emit('input', context.modelProp);
                }
            },
            validate()
            {
                let context = this;
                context.modelProp.Errors = [];
                if(context.model.Dni != "")
                {
                    if(context.model.Dni.length < 6 || context.model.Dni.length > 8){
                        context.modelProp.Validate = false;
                        context.modelProp.Errors.push("El Número de Documento debe tener un formato correcto.");
                        notificationHelpers.showError("Error!", "El Número de Documento debe tener un formato correcto.", context);
                    }
                    else
                    {
                        var param = { Aux: context.model.Dni };
                        axiosHelpers.axiosPost(
                            "Article/ValidateAndGetArticlesABCGol",
                            param,
                            context,
                            function(data) 
                            {
                                // -- Si valido OK
                                if(data.ResponseVM.ValidateResponse.Success)
                                {
                                    context.modelProp.Validate = true;
                                    context.model.FullName = data.ResponseVM.ValidateResponse.ResponseValidateItem.fullname;
                                    context.model.ClientID = data.ResponseVM.ValidateResponse.ResponseValidateItem.id;
                                    context.Packs = data.ResponseVM.GetArticlesResponse.ArticlePackList;
                                }
                                else
                                {
                                    context.modelProp.Errors.push("No se pudo validar el Número de Documento.");
                                }
                            }
                        );
                    }
                }
                else 
                {
                    context.modelProp.Errors.push("El Número de Documento debe tener un formato correcto."); 
                    notificationHelpers.showError("Error!", "El Número de Documento debe tener un formato correcto.", context);
                }
            }
        }
    }
</script>